import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Home, Key, TrendingUp, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { getLinkInBio } from "../api";

const ICONS = { home: Home, key: Key, "trending-up": TrendingUp, phone: Phone, "map-pin": MapPin };
const fmt = (n) => `\u00A3${Number(n || 0).toLocaleString()}`;

const LinkInBio = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { getLinkInBio().then(setCfg).catch(() => setCfg(null)); }, []);

  return (
    <div className="min-h-screen bg-[#1c1c1e] text-white flex flex-col items-center px-5 py-14" data-testid="link-in-bio">
      <div className="w-full max-w-[440px] flex flex-col items-center">
        <img src="/anadear_logo_light.png" alt="Anadear Estates" className="h-14 mb-6" />
        <h1 className="font-display text-[22px] font-400 text-center text-white">{cfg?.headline || "Anadear Estates"}</h1>
        <p className="text-[13px] text-white/50 text-center mt-1 mb-8">{cfg?.subtext || "Bath & Bristol property"}</p>

        <div className="w-full space-y-3">
          {(cfg?.links || []).map((l, i) => {
            const Icon = ICONS[l.icon] || ArrowUpRight;
            const internal = l.url?.startsWith("/");
            const cls = "group w-full flex items-center gap-3 px-5 py-4 rounded-2xl bg-white/[0.06] border border-white/10 hover:bg-[#b8935f] hover:border-[#b8935f] transition-all";
            const inner = (
              <>
                <Icon size={18} className="text-[#b8935f] group-hover:text-white transition-colors shrink-0" />
                <span className="text-[15px] font-500 flex-1">{l.label}</span>
                <ArrowUpRight size={16} className="text-white/40 group-hover:text-white transition-colors" />
              </>
            );
            return internal
              ? <Link key={i} to={l.url} className={cls} data-testid="lib-link">{inner}</Link>
              : <a key={i} href={l.url} target="_blank" rel="noreferrer" className={cls} data-testid="lib-link">{inner}</a>;
          })}
        </div>

        {cfg?.featured?.length > 0 && (
          <div className="w-full mt-10">
            <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 mb-3 text-center">Featured homes</p>
            <div className="space-y-3">
              {cfg.featured.map((p) => (
                <Link key={p.slug} to={`/property/${p.slug}`} className="flex items-center gap-3 p-2 rounded-2xl bg-white/[0.06] border border-white/10 hover:border-[#b8935f]/60 transition-colors" data-testid="lib-featured">
                  {p.image && <img src={p.image} alt="" className="w-16 h-16 rounded-xl object-cover" />}
                  <div className="min-w-0 flex-1">
                    <p className="text-[14px] font-500 truncate">{p.title}</p>
                    <p className="text-[13px] text-[#d9b98a]">{fmt(p.price)}{p.status === "to-rent" ? " pcm" : ""}</p>
                  </div>
                  <ArrowUpRight size={16} className="text-white/40 mr-2" />
                </Link>
              ))}
            </div>
          </div>
        )}

        <p className="text-[12px] text-white/30 mt-12">© {new Date().getFullYear()} Anadear Estates · Bath & Bristol</p>
      </div>
    </div>
  );
};

export default LinkInBio;
